export default "__VITE_ASSET__BhR6vobx__"